var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isMobile)?_c('pendanaan-desktop'):_c('pendanaan-mobile')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }